import React, { Component, Fragment, useEffect, useState, useRef } from 'react';
import './style.css';
import { useHistory, Link } from "react-router-dom"
import { Layout, Menu, Breadcrumb, Table, Button, Space, Form, Input, Row, Col, Checkbox, Divider, Card, Radio, Spin, Select } from 'antd';
import { MinusCircleOutlined, PlusOutlined, SearchOutlined, MoreOutlined, SyncOutlined } from '@ant-design/icons';
import Container from '../Layout/Container';
import { Wizard, Steps, Step } from 'react-albus';
import { useSelector, useDispatch } from 'react-redux';
import { addDirectorateAsyn, addDirectorateSelector, clearState } from './addDirectorateSlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
const { Header, Content, Footer } = Layout;
const { Search, TextArea } = Input;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;


export default function AddDirectorate() {
  const inputAddBranch = React.useRef(null);
  const [isToast, setToast] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [isDirectorate, setDirectorate] = React.useState(true);
  const dispatch = useDispatch();
  let history = useHistory();
  const [state, setState] = useState({})


  const { isFetching, isSuccess, isError, errorMessage } = useSelector(
    addDirectorateSelector
  );

  useEffect(() => {
    dispatch(clearState());
    // setTimeout(() => {
    //   setDirectorate(true);
    // }, 5000);

  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);

      toast.error(errorMessage.toUpperCase());

    }
    if (isSuccess) {
      dispatch(clearState());

      setTimeout(() => {
        setLoading(false);
        setToast(true);
        toast.success(errorMessage.toUpperCase());
        history.push('/departments');
      }, 1000);


    }
  }, [isError, isSuccess, setLoading, setToast]);


  const onFinish = values => {
    // console.log(values)
    //   let referenceNumber = values.arr_referenceNumber.map(function({referenceNumber}){
    //     return referenceNumber;
    // });

    //    let formData = [];
    //    let formObj = {"name":values.name,"referenceNumber":referenceNumber?referenceNumber:[],"description":values.description?values.description:''};
    //    formData.push(formObj);

    let formData = [];
    formData.push(values);

    let data = {
      "departmentName": "Chief of Air Staff",
      "code": "id",
      "data": formData
    };
    setLoading(true);
    dispatch(addDirectorateAsyn(data));

  }

  const onFinishFailed = (errorInfo) => {


  };

  return (
    <>
      <Container>
        <Breadcrumb style={{ margin: '16px 0', paddingLeft: 50, marginBottom: 0 }} separator=">">
          <Breadcrumb.Item><Link to={'/departments'}>Departments</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Add Independent Directorate</Breadcrumb.Item>
        </Breadcrumb>

        <div className="site-layout-content" style={{ marginTop: 0, paddingTop: 0 }}>

          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%', position: 'fixed', zIndex: 1111, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }
            <div>
              <Row style={{ backgroundColor: "#ffffff", paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                <Col span="6"></Col>
                <Col span="9" >
                  <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>Add Independent Directorate</h1>
                </Col>
                <Col span="9" style={{ paddingLeft: 25 }}>

                </Col>
              </Row>
              <Form
                layout="vertical"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 16 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row style={{ backgroundColor: "#ffffff", paddingTop: 24, paddingBottom: 40, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb' }}>
                  <Col span="6"></Col>
                  <Col span="18"  >
                    <br />
                    {/* <Form.Item >
                 <h2 style={{fontWeight:'bold',fontStyle:'normal',fontSize:22}}>Branch Details</h2>
              </Form.Item> */}
                    <Form.Item
                      rules={[{ required: true, message: 'Name is required' }]}
                      requiredMark={'optional'}
                      name={'name'} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Name*</p>}  >
                      <Input className="formInpt Input-my-css" placeholder="" />
                    </Form.Item>

                    <Form.List name="referenceNumber" initialValue={[{ ref: '', description: '' }]} >
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, fieldKey, ...restField }) => (
                            <Form.Item style={{ marginBottom: 0 }}>

                              <Form.Item
                                {...restField}
                                name={[name, 'ref']}
                                style={{ display: 'inline-block', width: 'calc(50% - 8px)', marginRight: 5 }}
                                // label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
                                label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Reference No*</p>}
                                fieldKey={[fieldKey, 'ref']}
                                rules={[{ required: true, message: 'Reference No is required' }]}
                                requiredMark={'optional'}
                              >
                                <Input className="formInput" placeholder="" />
                              </Form.Item>

                              <Form.Item
                                //name={'description'}
                                {...restField}
                                name={[name, 'description']}
                                fieldKey={[fieldKey, 'description']}
                                style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                label={key == 0 ? <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p></Col><Col style={{ textAlign: 'right' }} span={6}><Button style={{ marginBottom: 0, marginTop: 2, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%', marginBottom: -25 }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p></Col><Col style={{ textAlign: 'right' }} span={6}><Button style={{ marginBottom: -2, marginTop: 12, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => remove(name)} type="link"><MinusCircleOutlined /></Button></Col></Row>}
                              // label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
                              >

                                <TextArea style={{ lineHeight: 1.2 }} rows={0} className="formInput" placeholder="" />
                              </Form.Item>

                            </Form.Item>
                          ))}
                        </>
                      )}
                    </Form.List>

                    {/* <Form.List name="arr_referenceNumber" initialValue={[{referenceNumber:''}]} >
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }) => (
                    <Form.Item
                    {...restField}
                    name={[name,'referenceNumber']}
                    
                      label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
                      fieldKey={[fieldKey, 'referenceNumber']}
                      rules={[{ required: true, message: 'Reference No is required' }]}
                      requiredMark={'optional'}
                    >
                      <Input className="formInput" placeholder="" />
                    </Form.Item>
                  ))}
                </>
              )}
             </Form.List>

              <Form.Item
                name={'description'}
                label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
              >
                <TextArea rows={4} className="formInput" placeholder="" />
              </Form.Item> */}

                  </Col>
                </Row>

                <Row style={{ backgroundColor: "#ffffff", paddingTop: 24, paddingBottom: 24, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                  <Col span="6"></Col>
                  <Col span="12" style={{ textAlign: 'right', paddingRight: 10 }}>
                    <Space>
                      <Link to="/departments"><Button type="primary" size="large" ghost>Cancel</Button></Link>
                      <Button htmlType="submit" type="primary" size="large" >Submit</Button>
                    </Space>
                  </Col>
                  <Col span="5"></Col>

                </Row>
              </Form>
            </div>

          </div>

        </div>
      </Container>
    </>
  );
}
